import { Certifications, Welders } from "../welders";
import { Contractors } from "../contractors";
import { Projects } from "../projects";
import { ScopesOfWork } from "../scopeOfWork";
import { StandardTests } from "../standardTests";
import { TestEvents } from "../testEvents";

export function FavoritesView() {
  return (
    <ul>
      <li className="mb-3">
        <Projects filters={{ favorite: true }} />
      </li>
      <li className="mb-3">
        <ScopesOfWork filters={{ favorite: true }} />
      </li>
      <li className="mb-3">
        <Welders filters={{ favorite: true }} />
      </li>
      <li className="mb-3">
        <TestEvents filters={{ favorite: true }} />
      </li>
      <li className="mb-3">
        <Contractors filters={{ favorite: true }} />
      </li>
      <li className="mb-3">
        <Certifications filters={{ favorite: true }} />
      </li>
      <li className="mb-3">
        <StandardTests filters={{ favorite: true }} />
      </li>
    </ul>
  );
}
